/**
 * @module ErrorHandler
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
/* tslint:disable:no-any */
import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerService } from '@core/logger/services/logger.service';
import { SETTINGS } from '@environment/settings';
import { CommonUtilService } from '@support/shared/services/common-util.service';

/**
 * Service to handle all Errors, codes, status, etc.
 * @access public - global to all modules
 */
@Injectable()
export class CustomErrorHandler implements ErrorHandler {
  constructor(
    private logger: LoggerService,
    private commonUtils: CommonUtilService
  ) {}

  /**
   * Handles HTTP errors by sending out http events and logging them as well
   * @param error
   */
  public handleError(error: any): void {
    if (this.commonUtils.isNotEmpty(error)) {
      if (SETTINGS.ISLOGGERENABLE) {
        this.logger.fatal(
          'CustomErrorHandler',
          'CustomErrorHandler',
          'This log generated by CustomErrorHandler',
          'NA',
          error
        );
      } else {
        console.error(error);
      }
    }
  }
}
